import {NotificationService} from "../../services/NotificationService";
import {FileDataService} from "../../services/FileDataService";
import {MapAreaService} from "../../services/MapAreaService";
import {MapSiteService} from "../../services/MapSiteService";
import {MapArea} from "../../entities/MapArea";
import {MapSite} from "../../entities/MapSite";

export class CmdCenterSiteAreaModel {
    mapSites:MapSite[];
    selectedMapSite:MapSite;
    mapAreas:MapArea[];
    currentMapAreas:MapArea[];
    selectedMapArea:MapArea;
    imageData:string;
    static $inject = ['$q','MapSiteService','MapAreaService','FileDataService','NotificationService'];
    constructor(public $q:ng.IQService,
                public mapSiteService:MapSiteService,
                public mapAreaService:MapAreaService,
                public fileDataService:FileDataService,
                public notificationService:NotificationService)
    {
    }
    init(mapSiteId:number,mapAreaId:number):ng.IPromise<any> {
        return this.$q.all([this.mapSiteService.getAll(), this.mapAreaService.getAll()])
        .then((data)=>{
                this.mapSites = data[0];
                this.mapAreas = data[1];
                if(mapSiteId == null && mapAreaId != null){
                    for(var i=0;i<this.mapAreas.length;i++){
                        if(this.mapAreas[i].id === mapAreaId)
                            mapSiteId = this.mapAreas[i].mapSiteID;
                    }
                }
                if(!isNaN(mapSiteId))
                {
                    for(var i=0; i<this.mapSites.length; i++){
                        if(this.mapSites[i].id === mapSiteId)
                            this.selectedMapSite = this.mapSites[i];
                    }
                }
                else if(this.mapSites.length > 0) {
                    this.selectedMapSite = this.mapSites[0];
                }
                if(this.selectedMapSite != null)
                    this.updateMapAreas(this.selectedMapSite, mapAreaId);
        });
    }
    getBaseUrl():string{
        return this.fileDataService.getBaseUrl();
    }
    getMapAreaImage():ng.IPromise<boolean>{
      return this.fileDataService.get(this.selectedMapArea.fileDataID).then((b64Data)=>{
        this.imageData = b64Data;
        return this.$q.when<boolean>(true);
      });
    }
    updateMapAreas(mapSite:MapSite, defaultMapId?:number):ng.IPromise<boolean>{
        if(mapSite == null)
            return this.$q.when<boolean>(true);
        var mapSiteId = mapSite.id;
        this.selectedMapArea = null;
        this.currentMapAreas = [];
        for(var i=0; i<this.mapAreas.length;i++){
            if(this.mapAreas[i].mapSiteID === mapSiteId)
                this.currentMapAreas.push(this.mapAreas[i]);
            if(this.mapAreas[i].id === defaultMapId)
                this.selectedMapArea = this.mapAreas[i];
        }
        if(this.selectedMapArea == null && this.currentMapAreas.length > 0)
            this.selectedMapArea = this.currentMapAreas[0];
        else
            this.selectedMapArea = null;
        return this.$q.when<boolean>(true);
    }
    deleteSite():ng.IPromise<boolean>{
        if(this.selectedMapSite == null)
            return this.$q.when<boolean>(true);
        return this.mapSiteService.delete([this.selectedMapSite.id])
        .then(()=>{
            var mapSiteIndex = this.mapSites.indexOf(this.selectedMapSite);
            this.mapSites.splice(mapSiteIndex,1);
            if(this.mapSites.length > 0)
                this.selectedMapSite = this.mapSites[0];
            return this.$q.when<boolean>(true);
        });
    }
    deleteArea():ng.IPromise<boolean>{
        if(this.selectedMapArea == null)
            return this.$q.when<boolean>(true);
        return this.mapAreaService.delete([this.selectedMapArea.id])
        .then(()=>{
            this.mapAreas.splice(this.mapAreas.indexOf(this.selectedMapArea),1);
            this.currentMapAreas.splice(this.currentMapAreas.indexOf(this.selectedMapArea),1);
            if(this.currentMapAreas.length > 0)
                this.selectedMapArea = this.currentMapAreas[0];
            return this.$q.when<boolean>(true);
        });
    }
}
